import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../components/modal";
import { DropDownInput } from "../../wrappers/selectInput";
import DatepickerDefault from "../../components/daterangePicker";
import Button from "../../components/button";
import { getMilliSecUTC, skillNameConverter } from "../../utils/EllowUtils";
import { Icon } from '@iconify/react';
import Styles from "./styles.module.scss";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';

const { v4: uuidv4 } = require('uuid')

export type companyFilterFormFields = {
  companyType: any;
  dateWithin: any;
  companyStatus: any;
  allocatedTo: any;
  sourcedBy: any;
  skills?: any;
}

interface props {
  onClose?: any;
  ClickHandler?: any;
  defaultValues?: any;
  allocatedTo?: any;
  skillsList: any;
}

const CompanyFilter: React.FC<props> = ({
  onClose,
  ClickHandler,
  defaultValues,
  allocatedTo,
  skillsList
}) => {
  const formOptions = {    defaultValues: useMemo(() => {
    return defaultValues;
  }, [defaultValues])};

  const [address, setAddress] = useState('')
  const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])
  const skillvalues = skillsList && skillsList.length > 0 && skillNameConverter(skillsList) && skillNameConverter(skillsList).length > 0 && skillNameConverter(skillsList).map((item: any) => item.skillName);

  useEffect(() => {
    
    if(defaultValues){
      if(defaultValues.company && defaultValues.company === 'Hirer'){
        setValue('companyType',{name: 'Hirer', id: 1})
      } 
      if(defaultValues.company && defaultValues.company === 'Provider'){
        setValue('companyType',{name: 'Provider', id: 2})
      } 
      if(defaultValues.company && defaultValues.company === 'Both'){
        setValue('companyType',{name: 'Both', id: 3})
      } 
      if(defaultValues.status && defaultValues.status[0] === 'Approved'){
        setValue('companyStatus',{name: 'Approved', id: 3})
      }
      if(defaultValues.status && defaultValues.status[0] === 'Rejected'){
        setValue('companyStatus',{name: 'Rejected', id: 4})
      }
      if(defaultValues.status && defaultValues.status[0] === 'Pending'){
        setValue('companyStatus',{name: 'Pending', id: 1})
      }
      if(defaultValues.allocatedTo !== undefined){
        let allocated = allocatedTo.filter((item: any) => { return item.name === defaultValues.allocatedTo})
        setValue('allocatedTo',allocated[0])
      }
      if(defaultValues.googleLocations){
        let location = defaultValues.googleLocations.map((item: any) => {
          return({id: uuidv4() , name: item})
        })
        setLocationArray(location)
      }
    }
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ ]);


  const { register, handleSubmit, control, setValue } = useForm<companyFilterFormFields>(formOptions);

  const onSubmit = (data: any) => { 
    if(locationArray.length > 0){
      data.googleLocations  = locationArray.map((item: any) => {
        return( item.name )
      })  
    }
    ClickHandler(data)
  }

  const handleChange = (e: any, name: string) => { 
    if (name === "dateWithin") {
      let dateWithin = {
        fromDate: getMilliSecUTC(e.target.value.start),
        toDate: getMilliSecUTC(e.target.value.end),
      };
      setValue("dateWithin", dateWithin);
    }
  }

  const handleSelect = async (value: any) => {

    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }    
    setLocationArray([...locationArray, data])
    setAddress('')
  }

  const removeLocation = (item: any) => {
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }

  return (
    <Modal title={" "} size="small" onClose={onClose}>
      <form>
        <div className="half-form-wrap mb-0">
          <div className="form-group">
            <label className="lablel">Allocated To</label>
            <DropDownInput<companyFilterFormFields>
              name="allocatedTo"
              data={allocatedTo}
              control={control}
              register={register}
              textField='name'
              dataItemKey='id'
            />
          </div>
          <div className="form-group">
            <label className="lablel">Sourced by</label>
            <DropDownInput<companyFilterFormFields>
              name="sourcedBy"
              data={["RECRUITER","CUSTOMER","PROACTIVE"]}
              register={register}
              control={control}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="lablel">Date of registration</label>
          <DatepickerDefault
            defaultValue={defaultValues && defaultValues.dateWithin && {start: new Date(defaultValues.dateWithin.fromDate), end: new Date(defaultValues.dateWithin.toDate)}}
            onChange={(e: any) => handleChange(e, "dateWithin")}
          />
        </div>
        <div className="form-group">
          <label className="lablel">Skills</label>
            <MultiDropDownInput<companyFilterFormFields>
              name="skills"
              placeholder=""
              data={skillvalues}
              register={register}
              // errors={errors}
              control={control}
              allowCustom={false}
            />
        </div>
        <div className="form-group">
          <label className="lablel">Locations</label>
          {<PlacesAutocomplete
              value={address}
              onChange={setAddress}
              onSelect={handleSelect}
            >
            {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
              <div className="search-filed">
                <Icon icon="carbon:search"/>
                <input
                  {...getInputProps({
                    placeholder: 'Search Places ...',
                    className: 'location-search-input field',
                  })}
                />
                { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                  { loading ? <div className="suggestion-item">...loading</div> : null }
                    {suggestions.map(suggestion => {
                      return (
                        <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                          {suggestion.description}
                        </div>
                      )
                    })}
                    </div>
                }
              </div>
            )}
          </PlacesAutocomplete>}
        </div>
        <ul className={Styles.addressList}>
          {locationArray && locationArray.map((item: any) => {
            return (
              < li >
                <Icon icon="ep:location" className={Styles.location} />
                <div className={Styles.addressLine}>
                  <div>
                    {item.name}
                  </div>
                  <div className={Styles.addressAction}>
                    <Icon icon="icon-park-outline:delete" onClick={() => removeLocation(item)}/>
                  </div>
                </div>
              </li>
             )
            })
          }
        </ul>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Apply Filter
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default CompanyFilter;
